import BotsIcon from '@src/components/Icon/bots_menu.svg';
import TemplatesIcon from '@src/components/Icon/templates_menu.svg';
import BusinessManagerIcon from '@src/components/Icon/business_menu.svg';

export const MenuItems = [
  {
    icon: BotsIcon,
    title: 'Bots',
    tooltip: 'Bots',
    paths: ['/bots'],
  },
  {
    icon: TemplatesIcon,
    title: 'Smart Skills',
    tooltip: 'Smart Skills',
    paths: ['/smart-skills'],
  },
  {
    icon: BusinessManagerIcon,
    title: 'Business Manager',
    tooltip: 'Business Manager',
    paths: ['/businesses'],
  },
];
